export default "__VITE_ASSET__e9dfe390__"